import { render, staticRenderFns } from "./widgetReview.vue?vue&type=template&id=23f84402&scoped=true&"
import script from "./widgetReview.vue?vue&type=script&lang=js&"
export * from "./widgetReview.vue?vue&type=script&lang=js&"
import style0 from "./widgetReview.vue?vue&type=style&index=0&id=23f84402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f84402",
  null
  
)

export default component.exports